import {
    secondLineText,
    secondLineTextContainer,
} from 'owa-mail-listitem-styles/lib/scss/MailListItem.scss';

import { observer } from 'owa-mobx-react';
import { highlightTermsInHtmlElement } from 'owa-highlight';
import {
    type ConditionalFormattingModification,
    getConditionalFormattingStyles,
    ConditionalFormattingSurface,
} from 'owa-conditional-formatting';
import React from 'react';
import type { Accuracy } from 'owa-mark/lib/utils/markElements';

export interface MailListItemLineTextProps {
    addOverflowStyles: boolean;
    highlightTerms: string[];
    text: string;
    tooltipText: string;
    additionalStyles?: {
        [style: string]: string;
    };
    highlightAccuracy?: Accuracy;
    conditionalFormattingModifications?: ConditionalFormattingModification[];
}

const defaultExport: React.FunctionComponent<MailListItemLineTextProps> = observer(
    function MailListItemLineText(props: MailListItemLineTextProps): JSX.Element {
        const {
            addOverflowStyles,
            additionalStyles,
            highlightTerms: _highlightTerms,
            text,
            tooltipText,
            highlightAccuracy,
            conditionalFormattingModifications,
        } = props;

        const textStyle = React.useMemo(() => {
            const conditionalFormattingStyles =
                conditionalFormattingModifications && conditionalFormattingModifications.length > 0
                    ? getConditionalFormattingStyles(
                          ConditionalFormattingSurface.Text,
                          conditionalFormattingModifications
                      )
                    : undefined;

            if (additionalStyles) {
                return {
                    ...conditionalFormattingStyles,
                    ...additionalStyles,
                };
            }
            return { ...conditionalFormattingStyles };
        }, [additionalStyles, conditionalFormattingModifications]);

        const highlightTerms = React.useCallback(
            (element: HTMLDivElement) => {
                highlightTermsInHtmlElement(
                    element,
                    _highlightTerms,
                    false /* separateWordSearch */,
                    highlightAccuracy /* highlightAccurcy */
                );
            },
            [_highlightTerms]
        );

        return Object.keys(textStyle).length > 0 ? (
            <div style={textStyle} className={secondLineTextContainer}>
                <span
                    className={addOverflowStyles ? secondLineText : undefined}
                    title={tooltipText}
                    ref={highlightTerms}
                >
                    {text}
                </span>
            </div>
        ) : (
            <span
                className={addOverflowStyles ? secondLineText : undefined}
                title={tooltipText}
                ref={highlightTerms}
            >
                {text}
            </span>
        );
    },
    'MailListItemLineText'
);
export default defaultExport;
